<script>
  import { translate } from "../../../../i18n/i18next.js";
  import SidePanel from "../../../sidePanel/SidePanel.svelte";
  import SidePanelLinkCard from "../../../sidePanel/SidePanelLinkCard.svelte";
</script>

<SidePanel>
  <SidePanelLinkCard
    href="/"
    title={translate("frontend:pages.index.sidePanel.myProjects.title")}
    caption={translate("frontend:pages.index.sidePanel.myProjects.caption")}
  />
  <SidePanelLinkCard
    href="/admin/users"
    title={translate("frontend:pages.index.sidePanel.users.title")}
    caption={translate("frontend:pages.index.sidePanel.users.caption")}
    iconSrc="/assets/icons/icon_setting_inactive.png"
  />
  <SidePanelLinkCard
    href="/admin/projects"
    title={translate("frontend:pages.index.sidePanel.projects.title")}
    caption={translate("frontend:pages.index.sidePanel.projects.caption")}
    iconSrc="/assets/icons/icon_setting_inactive.png"
  />
  <SidePanelLinkCard
    href="/admin/server"
    title={translate("frontend:pages.index.sidePanel.server.title")}
    caption={translate("frontend:pages.index.sidePanel.server.caption")}
    iconSrc="/assets/icons/icon_setting_inactive.png"
  />
</SidePanel>
